<template>
  <li :class="classes" class="app-select-option"><slot /></li>
</template>

<script>
export default {
  name: "AppSelectOption",
  props: {
    selected: Boolean,
    hovered: Boolean
  },
  computed: {
    classes() {
      return {
        "is-selected": this.selected,
        "is-hover": this.hovered
      };
    }
  }
};
</script>

<style lang="scss">
.app-select-option {
  min-height: 28px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 3px 5px 3px 0;
  font-weight: 400;
  text-transform: none;
  position: relative;
  font-size: 15px;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }

  &.is-selected {
    color: #f72257;
  }

  &:hover,
  &.is-hover {
    color: lighten(#f72257, 10%);
  }
}
</style>
